import { fetcher } from "../../utils/fetcher.js";

export const markNotificationRead = (id) =>
  fetcher.put(`/api/notifications/${id}/read`);

export const markAllNotificationsRead = () =>
  fetcher.put("/api/notifications/read-all");
